module.exports = __webpack_public_path__ + "img/air_press.12bf48eb.png";